import React, { useEffect, useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import { impostaStrutturaNascosta } from '../../../api-client/appPlayer';

/*
 * Solo super admin (14/10/2026): la struttura si mostra o no nelle liste e nelle ricerche delle app Player e
 * Coach (e nel marketplace). Spenta, vince su tutto: la struttura non esce da nessuna parte nelle app; il super
 * admin la vede sempre. Interruttore sì/no che si salva subito (docs/sportid-ui.md, capitoli 8 e 10).
 */
export default function VisibilitaNelleListe({ clubId, nascosta, onErrore }) {
    const [valore, setValore] = useState(!!nascosta);
    const [inCorso, setInCorso] = useState(false);
    useEffect(() => { setValore(!!nascosta); }, [nascosta]);

    const cambia = async (mostra) => {
        const prima = valore;
        setValore(!mostra);
        setInCorso(true);
        const esito = await impostaStrutturaNascosta(clubId, !mostra);
        setInCorso(false);
        if (esito?.error) {
            setValore(prima);
            onErrore?.(esito.error);
        }
    };

    return (
        <Card>
            <Card.Body className="text-left">
                <h5 className="sid-form-section">Visibilità nelle app</h5>
                <Form.Check
                    type="switch"
                    id="struttura-visibile-nelle-liste"
                    label="Mostra la struttura nelle liste e nelle ricerche delle app Player e Coach"
                    checked={!valore}
                    disabled={inCorso || !clubId}
                    onChange={(e) => cambia(e.target.checked)}
                />
                <Form.Text className="sid-nota-leggibile" style={{ color: '#1A1A1A' }}>
                    Spenta, la struttura non compare in nessuna lista o ricerca delle app, qualunque altra impostazione abbia. Nel Manager resta visibile.
                </Form.Text>
            </Card.Body>
        </Card>
    );
}
